import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { staffApi, errMsg, fmtDate } from "./api";

const LABELS = {
  download: "Downloaded spreadsheet", sign_in: "Signed in", "2fa_enabled": "Turned on two-step sign-in",
  "2fa_reset": "Reset two-step sign-in", recovery_code_used: "Used a recovery code",
  recovery_codes_regenerated: "Made new recovery codes", password_set: "Set a new password",
  staff_added: "Added staff account", staff_updated: "Changed staff access", link_sent: "Sent password link",
  record_deleted: "Deleted a record", list_cleared: "Deleted a whole list",
  news_created: "Created article", news_published: "Published article", news_scheduled: "Scheduled article",
  news_unpublished: "Unpublished article", news_deleted: "Deleted article",
};

const detail = (a) => {
  if (a.action === "download") return `${a.list_title} (${a.rows} rows)`;
  if (a.action === "record_deleted") return `${a.list_title}: ${a.reference}`;
  if (a.action === "list_cleared") return `${a.list_title} (${a.rows} records)`;
  return a.target || "";
};

export const ActivityPanel = () => {
  const [items, setItems] = useState(null);
  const [onlyDownloads, setOnlyDownloads] = useState(true);
  const [error, setError] = useState("");
  useEffect(() => {
    staffApi.get("/admin/activity")
      .then((r) => setItems(Array.isArray(r.data) ? r.data : []))
      .catch(async (e) => setError(await errMsg(e)));
  }, []);
  if (error) return <p className="text-sm text-fire" role="alert">{error}</p>;
  if (!items) return <Loader2 className="animate-spin text-navy" />;
  const shown = onlyDownloads ? items.filter((a) => a.action === "download") : items;
  return (
    <div data-testid="staff-activity-panel">
      <label className="mb-6 inline-flex items-center gap-2 text-sm text-ink">
        <input type="checkbox" checked={onlyDownloads} onChange={(e) => setOnlyDownloads(e.target.checked)} data-testid="staff-activity-downloads-only-checkbox" />
        Show downloads only
      </label>
      {!shown.length && <p className="text-sm text-slate" data-testid="staff-activity-empty">Nothing recorded yet.</p>}
      <ul className="divide-y divide-mist border border-mist bg-white">
        {shown.map((a, i) => (
          <li key={`${a.at}-${i}`} className="grid gap-1 p-4 text-sm md:grid-cols-[180px_1fr_1.4fr]" data-testid="staff-activity-row">
            <span className="text-slate">{fmtDate(a.at)}</span>
            <span className="font-semibold text-navy">{a.user_name || a.user_email}</span>
            <span className="text-ink">{LABELS[a.action] ?? a.action}{detail(a) ? ` · ${detail(a)}` : ""}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};
